<template>
    <ResourceInput
        label="Summary bullets override"
        attribute="summaryBulletsOverride"
        type="richtext"
    />
</template>
